module.exports = __webpack_public_path__ + "img/32.4ee427da.png";